import type { QuestionType } from '@mentimeter/http-clients';
import type { QuestionWithSlide } from '@mentimeter/presentation-schema/api-types-overrides';

const OLD_DATA_MODE_QUIZ_SLIDE_TYPES = new Set<QuestionType>([
  'quiz',
  'quiz_open',
  'quiz_leaderboard',
]);

const NEW_DATA_MODE_QUIZ_SLIDE_TYPES = new Set<
  QuestionWithSlide['staticContent']['type']
>(['quiz-choice', 'quiz-open', 'leaderboard']);

const isOldDataModeQuizSlideType = (type: string): type is QuestionType =>
  OLD_DATA_MODE_QUIZ_SLIDE_TYPES.has(type as QuestionType);

const isNewDataModeQuizSlideType = (
  type: string,
): type is QuestionWithSlide['staticContent']['type'] =>
  NEW_DATA_MODE_QUIZ_SLIDE_TYPES.has(
    type as QuestionWithSlide['staticContent']['type'],
  );

/**
 * @deprecated Use the overloaded version with QuestionWithSlide['staticContent']['type'] instead
 */
export function getIsQuizSlide(type: QuestionType): boolean;
export function getIsQuizSlide(
  type: QuestionWithSlide['staticContent']['type'],
): boolean;
export function getIsQuizSlide(type: string): boolean {
  return isOldDataModeQuizSlideType(type) || isNewDataModeQuizSlideType(type);
}
